import { render, staticRenderFns } from "./pc-signature.vue?vue&type=template&id=bc6ad28c&scoped=true&"
import script from "./pc-signature.vue?vue&type=script&lang=ts&"
export * from "./pc-signature.vue?vue&type=script&lang=ts&"
import style0 from "./pc-signature.vue?vue&type=style&index=0&id=bc6ad28c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6ad28c",
  null
  
)

export default component.exports